<div class="card-container" (click)="openPatientProfile(row); $event.stopPropagation()"
    [ngClass]="{'blinker-row': row.notificationStatus && memberService.getLoginUserRole() == enumRole.INSURER}">

    <div class="d-flex justify-content-between align-items-start">
        <div class="d-flex align-items-center gap-3">
            <div class="avatar-box-modern">
                <span class="initials">
                    {{row.firstName | initials : row.lastName}}
                </span>
            </div>

            <div class="d-flex flex-column">
                <h5 class="fw-500 mb-1">
                    {{ row.firstName }} {{ row.lastName }}
                    <span *ngIf="row.notificationStatus && memberService.getLoginUserRole() == enumRole.INSURER"
                        class="wifi-blinker ms-2" matTooltip="More info requested"></span>
                </h5>
                <div class="gray-text fs-11">
                    {{ row.dateOfBirth | age }}, {{ row.gender.charAt(0) }}
                </div>
            </div>

        </div>


        <div *ngIf="row.serviceRequest.status != 'REQUESTED' && row.serviceRequest.status != 'RECEIVED' && row.serviceRequest.assignedProvider && row.serviceRequest.assignedProvider.id == userId
            && memberService.getLoginUserRole() == enumRole.PROVIDER">
            <span [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" (click)="$event.stopPropagation();"
                class="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="#5e5d5d"
                        d="M7 12a2 2 0 1 1-4 0a2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0" />
                </svg>
            </span>
            <mat-menu #menu="matMenu" style="background: white !important;padding: 0px !important;">
                @if(memberService.getLoginUserRole() == enumRole.PROVIDER && row.serviceRequest.status != 'REQUESTED') {
                <button mat-menu-item (click)="onRequestMoreDetails(row); menuTrigger.closeMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 48 48">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            d="M12 30.872h11.462M12 23.915h11.462M12 16.957h4.487m27.013 7.24V9.402L30.646 16.8zm-5.396 1.956v10.43a4 4 0 0 1-4 4H8.5a4 4 0 0 1-4-4V11.417a4 4 0 0 1 4-4h29.653"
                            stroke-width="1.2" />
                    </svg> &nbsp; <span class="fs-12">Request more details</span>
                </button>

                <button mat-menu-item (click)="openMedicalEvidence(row); menuTrigger.closeMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                        <path fill="#6a6868" fill-rule="evenodd"
                            d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118m-1.687.412L18 4.061l-8.518 8.518l-.625 2.393l2.393-.625z"
                            clip-rule="evenodd" />
                        <path fill="#6a6868"
                            d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516" />
                    </svg> &nbsp; <span class="fs-12">Submit medical evidence</span>
                </button>
                }
                @else{
                <!-- <button mat-menu-item (click)="openAddPatientModal(row); menuTrigger.closeMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                        <path fill="#6a6868" fill-rule="evenodd"
                            d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118m-1.687.412L18 4.061l-8.518 8.518l-.625 2.393l2.393-.625z"
                            clip-rule="evenodd" />
                        <path fill="#6a6868"
                            d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516" />
                    </svg> &nbsp; <span class="fs-12">Edit details</span>
                </button>

                <button mat-menu-item (click)="openRequestME(row); menuTrigger.closeMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="1.5">
                            <path
                                d="M13.578 16.775a.97.97 0 0 0-.31-.715L7.3 10.554L1.33 16.06a.97.97 0 0 0-.309.715v5.37a.966.966 0 0 0 .966.966h10.626a.966.966 0 0 0 .966-.966zm3.419-9.049a3.419 3.419 0 1 0 0-6.837a3.419 3.419 0 0 0 0 6.837" />
                            <path
                                d="M16.423 23.111h3.138l.855-6.838h2.564V13.71a5.983 5.983 0 0 0-11.037-3.202m-4.644 5.125v4.834m2.417-2.417H4.88" />
                        </g>
                    </svg> &nbsp; <span class="fs-12">Request ME</span>
                </button> -->

                @if(row.notificationStatus){
                <button mat-menu-item (click)="onFillMoreInfo(row); menuTrigger.closeMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 48 48">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            d="M12 30.872h11.462M12 23.915h11.462M12 16.957h4.487m27.013 7.24V9.402L30.646 16.8zm-5.396 1.956v10.43a4 4 0 0 1-4 4H8.5a4 4 0 0 1-4-4V11.417a4 4 0 0 1 4-4h29.653"
                            stroke-width="1.2" />
                    </svg> &nbsp; <span class="fs-12">Fill requested details</span>
                </button>
                }

                }
            </mat-menu>
        </div>

        <div
            *ngIf="row.serviceRequest.status != 'REQUESTED' && row.serviceRequest.status != 'RECEIVED' && memberService.getLoginUserRole() == enumRole.INSURER">
            <span [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" (click)="$event.stopPropagation();"
                class="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="#5e5d5d"
                        d="M7 12a2 2 0 1 1-4 0a2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0" />
                </svg>
            </span>
            <mat-menu #menu="matMenu" style="background: white !important;padding: 0px !important;">
                <!-- <button mat-menu-item (click)="openAddPatientModal(row); menuTrigger.closeMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                        <path fill="#6a6868" fill-rule="evenodd"
                            d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118m-1.687.412L18 4.061l-8.518 8.518l-.625 2.393l2.393-.625z"
                            clip-rule="evenodd" />
                        <path fill="#6a6868"
                            d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516" />
                    </svg> &nbsp; <span class="fs-12">Edit details</span>
                </button>

                <button mat-menu-item (click)="openRequestME(row); menuTrigger.closeMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="1.5">
                            <path
                                d="M13.578 16.775a.97.97 0 0 0-.31-.715L7.3 10.554L1.33 16.06a.97.97 0 0 0-.309.715v5.37a.966.966 0 0 0 .966.966h10.626a.966.966 0 0 0 .966-.966zm3.419-9.049a3.419 3.419 0 1 0 0-6.837a3.419 3.419 0 0 0 0 6.837" />
                            <path
                                d="M16.423 23.111h3.138l.855-6.838h2.564V13.71a5.983 5.983 0 0 0-11.037-3.202m-4.644 5.125v4.834m2.417-2.417H4.88" />
                        </g>
                    </svg> &nbsp; <span class="fs-12">Request ME</span>
                </button> -->

                @if(row.notificationStatus){
                <button mat-menu-item (click)="onFillMoreInfo(row); menuTrigger.closeMenu()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 48 48">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            d="M12 30.872h11.462M12 23.915h11.462M12 16.957h4.487m27.013 7.24V9.402L30.646 16.8zm-5.396 1.956v10.43a4 4 0 0 1-4 4H8.5a4 4 0 0 1-4-4V11.417a4 4 0 0 1 4-4h29.653"
                            stroke-width="1.2" />
                    </svg> &nbsp; <span class="fs-12">Fill requested details</span>
                </button>
                }
            </mat-menu>
        </div>

    </div>

    <div class="info-block p-3 rounded shadow-sm bg-white mt-2">

        <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="icon">
                <path fill="none" stroke="currentColor"
                    d="M7.5 6V1m10 5V1m4 16v4.5h-18v-3m17.863-10H3.352M.5 18.25v.25h17.9l.15-.25l.234-.491A28 28 0 0 0 21.5 5.729V3.5h-18v2.128A28 28 0 0 1 .743 17.744z"
                    stroke-width="1" />
            </svg>
            <span class="gray-text fs-11">Requested On:</span> <span class="info-text"><span class="info-text fs-11">{{
                    row.createdon
                    | date :
                    'dd/MM/yyyy HH:mm' }}</span></span>
        </div>

        <div class="info-item d-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon" aria-hidden="true">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M11 8v5h5" />
                </g>
            </svg>
            <span class="gray-text fs-11">Turn around time:</span> <span
                class="info-text fs-11">{{getTurnAroundTime(row)}}</span>

            @if(row.serviceRequest.status=='REQUESTED'){
            <span class="ms-auto gray-text fs-11 cursor-pointer"
                (click)="openAssignPopup(row); $event.stopPropagation()">
                <div class="avatar" style="box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);background: #8080802b;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <g fill="none" stroke="#909090" stroke-linecap="round" stroke-width="1">
                            <circle cx="12" cy="8" r="3.5" />
                            <path
                                d="M4.85 16.948c.639-2.345 3.065-3.448 5.495-3.448h3.31c2.43 0 4.856 1.103 5.496 3.448a10 10 0 0 1 .295 1.553c.06.55-.394.999-.946.999h-13c-.552 0-1.005-.45-.946-.998a10 10 0 0 1 .295-1.554Z" />
                        </g>
                    </svg>
                </div>
            </span>
            }
            @else{
            <span class="ms-auto gray-text fs-11 cursor-pointer"
                [matTooltip]="'Agent Assigned : ' + getAssignedAgentFullName(row)"
                (click)="openAssignPopup(row); $event.stopPropagation()">
                <div class="avatar" style="box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);">
                    {{ getAssignedAgent(row) }}
                </div>
            </span>
            }

        </div>

        <div class="info-footer d-flex justify-content-between align-items-center mt-3">
            <div class="gray-text fs-11">
                Updated On: {{ row.lastupdatedon | date:'dd/MM/yyyy HH:mm' }}
            </div>
            <!-- <div class="status-container">
                <app-status-lables [entityType]="enumEntityType.INSURER"
                    [status]="row.serviceRequest.status == 'REQUESTED' ? 'PROCESSING' : row.serviceRequest.status == 'RECEIVED' ? 'SUBMITTED' : row.serviceRequest.status"></app-status-lables>
            </div> -->
        </div>

        <div class="add-task-button" (click)="openAssignPopup(row);$event.stopPropagation()"
            *ngIf="row.serviceRequest.status != 'RECEIVED'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path fill="#0075C9"
                    d="M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6"
                    stroke-width="0.1" stroke="#0075C9" />
                <path fill="#0075C9" d="M8 11.5c-.28 0-.5-.22-.5-.5V5c0-.28.22-.5.5-.5s.5.22.5.5v6c0 .28-.22.5-.5.5"
                    stroke-width="0.1" stroke="#0075C9" />
                <path fill="#0075C9" d="M11 8.5H5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h6c.28 0 .5.22.5.5s-.22.5-.5.5"
                    stroke-width="0.1" stroke="#0075C9" />
            </svg>&nbsp;
            {{ row.serviceRequest.status=='REQUESTED' ? 'Assign' : 'Reassign'}} Request To
        </div>

        <!-- <div class="add-task-button" *ngIf="row.serviceRequest.status == 'RECEIVED'">

        </div> -->

    </div>

    <div class="assign-modal" *ngIf="isAssignModalVisible" [ngClass]="{
    'slide-down': closingRowId === row.patientId,
    'slide-up': openedRowId === row.patientId && closingRowId !== row.patientId
  }" (click)="$event.stopPropagation()">
        <div class="assign-modal-header">
            <p class="fs-13 fw-500">{{ row.serviceRequest.status=='REQUESTED' ? 'Assign' : 'Reassign'}} Request</p>
            <span class="fs-25 close-btn" (click)="toggleAssignPopup(row.patientId);$event.stopPropagation()">×</span>
        </div>
        <div class="w-100">
            <mat-form-field appearance="outline" class="search-field-agent">
                <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                        stroke="#0075C9" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                    </svg>
                </span>
                <input matInput placeholder="Search Agents" (click)="$event.stopPropagation()"
                    [(ngModel)]="searchQuery" />
            </mat-form-field>
        </div>
        <!-- Scrollable User List -->
        <div class="user-list-scroll scroll-content mt-2">
            <div class="user-card" *ngFor="let user of filteredUsers(); let i = index" [ngClass]="{
    'selected': selectedUser === user.userId,
    'border-bottom': selectedUser !== user.userId
  }" (click)="selectUser(user)">

                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center gap-2">
                        <div class="avatar">
                            {{ user.firstName.charAt(0) }}{{ user?.lastName?.charAt(0) }}
                        </div>
                        <div class="user-details">
                            <div class="fw-500 fs-12">{{ user.firstName }} {{ user?.lastName }} 
                                @if(userId == user.userId){
                                    <span class="fs-10 gray-text">(Assign to me)</span>
                                }
                            </div>
                            <div class="text-muted fs-10">{{ user.phone }}</div>
                        </div>
                    </div>
                    <div *ngIf="selectedUser === user.userId">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                            <path fill="#64c54c" fill-rule="evenodd"
                                d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                                clip-rule="evenodd" stroke-width="0.1" stroke="#64c54c" />
                        </svg>
                    </div>
                    <div *ngIf="selectedUser !== user.userId">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                            <path fill="#0075C9"
                                d="M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6"
                                stroke-width="0.1" stroke="#0075C9" />
                            <path fill="#0075C9"
                                d="M8 11.5c-.28 0-.5-.22-.5-.5V5c0-.28.22-.5.5-.5s.5.22.5.5v6c0 .28-.22.5-.5.5"
                                stroke-width="0.1" stroke="#0075C9" />
                            <path fill="#0075C9"
                                d="M11 8.5H5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h6c.28 0 .5.22.5.5s-.22.5-.5.5"
                                stroke-width="0.1" stroke="#0075C9" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>